<template>
  <v-navigation-drawer color="#121212" location="right" permanent>

    <router-link class="text-no-decoration pa-10" :to="{ name: 'page-home' }">
      <v-img class="mx-auto mt-5 pa-16" :src="$store.getters.getLogoUrl" max-width="60%" contain
        alt="کره فای - پلتفرم اختصاصی دانلود و پخش آنلاین آهنگ سریال های کره ای">
      </v-img>
    </router-link>

    <v-list density="compact" nav dir="rtl">
      <v-list-item prepend-icon="mdi-home" title="خانه" :to="{ name: 'page-home' }" value="خانه"
        class="text-white text-capitalize"></v-list-item>
      <v-list-item prepend-icon="mdi-magnify" title="جستجو" :to="{ name: 'page-search' }" value="جستجو"
        class="text-white text-capitalize"></v-list-item>
      <v-list-item prepend-icon="mdi-play-box-multiple" title="دسته بندی" :to="{ name: 'page-explore' }"
        value="دسته بندی" class="text-white text-capitalize"></v-list-item>
      <!-- <v-list-item prepend-icon="mdi-newspaper-variant" title="بلاگ" :to="{ name: 'page-blog' }" value="بلاگ"
        class="text-white text-capitalize"></v-list-item> -->
      <v-list-item prepend-icon="mdi-bookmark" title="پلی لیست های من" :to="{ name: 'page-library' }"
        value="پلی لیست های من" class="text-white text-capitalize"></v-list-item>
    </v-list>

    <v-row :class="['mx-1 w-100', { 'desktop-navs': player.visible, 'desktop-navs-inpl': !player.visible }]">
      <a :href="settings.telegram_chanel_url" target="_blank" class="w-100 mb-8 align-center">
        <v-img alt="کانال تلگرام کره فای" :class="['px-4']" :src="settings.telegram_banner_url"></v-img>
      </a>

      <span class="mx-auto">
        <router-link :to="{ name: 'page-about' }" :class="['px-2 text-no-decoration text-white']">درباره
          ما</router-link>
        <router-link :to="{ name: 'page-terms' }" :class="['px-2 text-no-decoration text-white']">قوانین
          استفاده</router-link>
        <router-link :to="{ name: 'page-policy' }" :class="['px-2 text-no-decoration text-white']">حریم خصوصی</router-link>
      </span>



    </v-row>

  </v-navigation-drawer>
</template>

<script>


export default {

  computed: {
    player() {
      return this.$store.getters.getPlayerProps;
    },

    settings() {
      return this.$store.getters.settings;
    }

  },

  methods: {
    setCurrentTrack(track) {
      this.$store.commit('setCurrentTrack', track);
    },

    setCurrentTrackAsync(track) {
      this.$store.dispatch('setCurrentTrackAsync', track);
    }
  }
};

</script>

<style>
.desktop-navs {
  position: absolute;
  bottom: 120px;
  font-size: 10px;
}

.desktop-navs-inpl {
  position: absolute;
  bottom: 25px;
  font-size: 10px;
}

.banner-shadow {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease-in-out;
}

.banner-shadow:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
}
</style>
